export const todayPanama = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Panama', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
export const manualParameters = () => ({ committed: 0, transit: 0, quarantine: 0, unusable: 0, lead: 0, sd: 0, safety: 0, min: 0, review: 0, units: 0, unit: 0, oldUnit: 0, freight: 0, insurance: 0, tariff: 0, inland: 0, volumeFactor: 1, discount: 0, advance: 0, urgentLead: 0, urgentExtra: 0, provider: '', salesFactor: 0, stockFactor: 0 });
export const emptyEntry = () => ({ parameters: manualParameters(), stockouts: [] });
export function periodTotals(product, start, end, customerId) {
    const seen = new Set();
    let invoices = 0, credits = 0, incomplete = false;
    for (const tx of product.transactions) {
        if (customerId && tx.customerId !== customerId) continue;
        if (!/^\d{4}-\d{2}-\d{2}$/.test(tx.date)) { incomplete = true; continue; }
        if (tx.date < start || tx.date > end || tx.voided) continue;
        const key = `${tx.type}:${tx.id}:${tx.line}`;
        if (seen.has(key)) continue;
        seen.add(key);
        if (!Number.isFinite(tx.quantity)) { incomplete = true; continue; }
        if (tx.type === 'Invoice') invoices += tx.quantity;
        if (tx.type === 'CreditMemo') credits += tx.quantity;
    }
    return { invoices, credits, net: incomplete ? null : invoices - credits, incomplete };
}
export function demandInput(product, parameters, start, end) {
    if (!(parameters.salesFactor > 0)) return { error: 'Confirme las cajas por unidad facturada para calcular demanda.' };
    if (periodTotals(product, start, end).incomplete) return { error: 'Hay líneas sin cantidad o fecha verificable; revise la fuente.' };
    return { product: { ...product, historyStart: start, cutoff: end, transactions: product.transactions.map(tx => ({ ...tx, quantity: tx.quantity === null ? null : tx.quantity * parameters.salesFactor })) } };
}
export function availableBoxes(product, parameters) {
    if (!Number.isFinite(product.qtyOnHand) || !(parameters.stockFactor > 0)) return null;
    return product.qtyOnHand * parameters.stockFactor;
}
